import axios from 'axios'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { constants } from '../Constants'
import { Badge } from '../components/ui'
import { PageLoader } from '../components/ui/Spinner/Spinner'
import '../styles/shared.scss'

export const Inscriptions = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [inscriptions, setInscriptions] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const getInscriptions = async () => {
    try {
      const response = await axios.get(
        `${constants.urlLocal}inscription/user/${user.id}`
      )
      setInscriptions(response.data.inscriptions)
    } catch (error) {
      console.error('Error al obtener las inscripciones', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getInscriptions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const sortedInscriptions = inscriptions
    .filter(i => moment().diff(moment(i.eventId.end), 'hours') < 2)
    .sort((a, b) => moment(a.eventId.start).diff(moment(b.eventId.start)))

  if (isLoading)
    return (
      <div className="loading-center">
        <PageLoader />
      </div>
    )

  return (
    <div className="page-container">
      <h2 className="page-title" style={{ textAlign: 'center' }}>
        Mis Inscripciones
      </h2>
      <p className="page-subtitle" style={{ textAlign: 'center' }}>
        Clases a las que te has inscrito
      </p>

      <div className="card-box" style={{ marginBottom: '1.5rem' }}>
        <h3
          style={{
            textAlign: 'center',
            fontWeight: 700,
            marginBottom: '0.75rem',
          }}
        >
          Tus próximas clases
        </h3>
        {sortedInscriptions.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#999' }}>
            No tienes inscripciones futuras
          </p>
        ) : (
          <div
            style={{
              display: 'grid',
              gap: '0.75rem',
              maxWidth: '400px',
              margin: '0 auto',
            }}
          >
            {sortedInscriptions.map(inscription => (
              <Link
                to={`/event/${inscription.eventId._id}`}
                key={inscription._id}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div
                  className="card-box"
                  style={{
                    borderLeft: `4px solid ${inscription.eventId.color}`,
                    cursor: 'pointer',
                    transition: 'transform 0.2s',
                  }}
                  onMouseOver={e =>
                    (e.currentTarget.style.transform = 'scale(1.02)')
                  }
                  onMouseOut={e =>
                    (e.currentTarget.style.transform = 'scale(1)')
                  }
                >
                  <div className="flex-between">
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                      }}
                    >
                      <span
                        style={{
                          width: 8,
                          height: 8,
                          borderRadius: '50%',
                          background: inscription.eventId.color,
                          display: 'inline-block',
                        }}
                      />
                      <strong>{inscription.eventId.title}</strong>
                    </div>
                    <Badge
                      variant={
                        moment().isSame(inscription.eventId.start, 'day')
                          ? 'primary'
                          : 'info'
                      }
                    >
                      {moment(inscription.eventId.start).calendar(null, {
                        sameDay: '[Hoy]',
                        nextDay: '[Mañana]',
                        nextWeek: 'dddd',
                        lastDay: '[Ayer]',
                        lastWeek: '[El] dddd [pasado]',
                        sameElse: 'DD/MM/YYYY',
                      })}
                    </Badge>
                  </div>
                  <p
                    style={{
                      fontSize: '0.8rem',
                      color: '#999',
                      marginTop: '0.25rem',
                    }}
                  >
                    📅{' '}
                    {moment(inscription.eventId.start)
                      .local()
                      .format('DD MMMM - HH:mm')}{' '}
                    a {moment(inscription.eventId.end).local().format('HH:mm')}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
